module.exports = __webpack_public_path__ + "static/unveiled-77a366d972d875d3521161ddb2ea798a.gif";